module.exports = __webpack_public_path__ + "assets/img/202110-1.7fa3f876.png";